import script from "./face-auth-result.vue?vue&type=script&lang=tsx&setup=true"
export * from "./face-auth-result.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__